import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';
import type { Gender } from '../modal/student';

export interface Enrollment {
  enrollmentId: string; // classId
}

export interface StudentFormData {
  dob: string;
  gender: Gender;
  mobileNo: string;
  firstName: string;
  lastName: string;
  parentId: string;
  studioId: string;
  studentEmail: string;
  tShirtSize: string;
  transportation: string;

  medical: {
    allergies: string;
    primaryDoctor: string;
    medications: string;
    disabilities: string;
    specialNeeds: string;
    healthInsuranceCarrier: string;
  };

  // enrollments: Array<Enrollment>;
  // policies: {
  //   agreedPolicies: Array<{
  //     policyId: string;
  //     title: string;
  //     status: 'agreed' | 'disagreed';
  //   }>;
  // };
}

export interface StudentMatchResponse {
  matchType: 'hard' | 'near' | 'none';
  existingStudent?: {
    _id: string;
    firstName: string;
    lastName: string;
    dob?: string;
  };
  similarity?: number;
  message?: string;
}

export const createStudents = async (
  params: StudentFormData & { skipMatching?: boolean },
): Promise<unknown | StudentMatchResponse> => {
  const response = await baseAPI.post<unknown | StudentMatchResponse>(
    '/students/with-location',
    params,
  );

  return response.data;
};

export const useCreateStudentMutation = () => {
  return useMutation({
    mutationFn: createStudents,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.STUDENTS,
      });
    },
  });
};
